module.exports = __webpack_public_path__ + "assets/img/trend.f0aa8287.png";